import React from "react"
import { FormattedMessage } from "react-intl"
import { InvoiceDto } from "../../../state/invoice/models"
import Proposal from "../../../state/proposal/Proposal"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"

const IntegrationKey = "shopify-expert-app"
type OwnProps = {
    object: EventObjectDto
    quote: InvoiceDto
    proposal: Proposal
}

const QuoteExportedToShopifyEvent = (props: OwnProps) => {


    const renderMessage = () => {
        return <FormattedMessage
            id="quote.analytics.events.exported.shopify.text"
            defaultMessage="Quote {identifier} has been exported to Shopify as a completed order"
            values={{
                identifier: <strong>{props.quote.attributes.identifier}</strong>,
            }}
        />
    }

    const shopifyUrl =
        Integrations.getPaymentTransactionExternalUrl(props.object)

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={shopifyUrl} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(IntegrationKey, 75, 50)}
                    </a>
                </div>
                {shopifyUrl &&
                <div className={""}>
                    <p className={"mb-0"}>
                        <a href={shopifyUrl} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                            <FormattedMessage
                                id="invoice.analytics.events.exported.shopify.open"
                                defaultMessage="Open order in shopify"
                            />
                        </a>
                    </p>
                </div>
                }
            </div>
        </div>
    )
}


export default QuoteExportedToShopifyEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-shopify.component.tsx